'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var React = require('react');

const ProductListContext = React.createContext({ products: [], setProducts: () => {
} });
const ProductListProvider = ({
  children
}) => {
  const [products, setProducts] = React.useState([]);
  const [showBlock, setShowBlock] = React.useState(true);
  const _setProducts = React.useCallback(setProducts, []);
  const _setShowBlock = React.useCallback(setShowBlock, []);
  return /* @__PURE__ */ jsxRuntime.jsx(ProductListContext.Provider, {
    value: {
      products,
      setProducts: _setProducts,
      showBlock,
      setShowBlock: _setShowBlock
    },
    children
  });
};
function useProductList() {
  const context = React.useContext(ProductListContext);
  if (!context) {
    throw new Error(
      "useProductList must be inside a ProductListContext with a state value"
    );
  }
  return context;
}

exports.ProductListContext = ProductListContext;
exports.ProductListProvider = ProductListProvider;
exports.useProductList = useProductList;
